import { render } from "./errorPage3.vue?vue&type=template&id=46f30226&scoped=true"
const script = {}

import "./errorPage3.vue?vue&type=style&index=0&id=46f30226&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f30226"]])

export default __exports__